import React from 'react';

const STATUS_DOT = {
	pending_acceptance: 'bg-yellow-500',
	open: 'bg-blue-500',
	active: 'bg-green-500',
	completed: 'bg-green-500',
	failed: 'bg-gray-400',
	expired: 'bg-gray-400',
	declined: 'bg-gray-400',
	cancelled: 'bg-gray-400'
};

const STATUS_TEXT = {
	pending_acceptance: 'text-yellow-700 dark:text-yellow-400',
	open: 'text-blue-700 dark:text-blue-400',
	active: 'text-green-700 dark:text-green-400',
	completed: 'text-green-700 dark:text-green-400',
	failed: 'text-gray-500 dark:text-gray-400',
	expired: 'text-gray-500 dark:text-gray-400',
	declined: 'text-gray-500 dark:text-gray-400',
	cancelled: 'text-gray-500 dark:text-gray-400'
};

function statusLabel(status) {
	if (status === 'failed') return "Didn't complete";
	if (status === 'pending_acceptance') return 'Pending';
	return status.charAt(0).toUpperCase() + status.slice(1);
}

export default function ChallengeStatusIndicator({ status }) {
	const dotClass = STATUS_DOT[status] || STATUS_DOT.active;
	const textClass = STATUS_TEXT[status] || 'text-gray-500 dark:text-gray-400';

	return (
		<span className={`inline-flex shrink-0 items-center gap-1.5 text-xs font-normal ${textClass}`}>
			<span className={`h-1.5 w-1.5 rounded-full ${dotClass}`} aria-hidden="true" />
			{statusLabel(status)}
		</span>
	);
}
